import React, { useState } from 'react';
import { FormControl, Button, ButtonGroup } from 'react-bootstrap';
import Select from 'react-select';  // Importa react-select
import { Search, XSquare } from 'react-bootstrap-icons';

function FiltroFacturas({ onFilter }) {
    const [factura, setFactura] = useState('');
    const [cliente, setCliente] = useState('');
    const [numGuia, setGuia] = useState('');
    const [creacion, setCreacion] = useState('');
    const [vence, setVence] = useState('');
    const [total, setTotal] = useState('');
    const [fraElectronica, setFraElectronica] = useState('');
    const [estado, setEstado] = useState('');  // Nuevo estado para el filtro de estado

    // Opciones para el select de estados
    const estadoOptions = [
        { value: 'pendiente', label: 'Pendiente' },
        { value: 'pagado', label: 'Pagado' },
        { value: 'vencido', label: 'Vencido' },
        { value: 'anulado', label: 'Anulado' }
    ];

    // Función para limpiar valores numéricos
    const formatValue = (value) => {
        return value.replace(/[^0-9]/g, '');
    };

    // Función para validar y formatear fechas en formato YYYY-MM-DD
    const formatDate = (value) => {
        return value;
    };

    const handleSearch = () => {
        onFilter({
            factura,
            cliente,
            numGuia,
            creacion: formatDate(creacion),
            vence: formatDate(vence),
            total: formatValue(total),
            fraElectronica,
            estado: estado ? estado.value : ''  // Envía el valor del estado si está seleccionado
        });
    };

    const handleClear = () => {
        setFactura('');
        setCliente('');
        setGuia('');
        setCreacion('');
        setVence('');
        setTotal('');
        setFraElectronica('');
        setEstado('');  // Limpiar el select de estado
        onFilter({});
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className='d-flex align-items-center m-3'>
            <FormControl
                placeholder='Factura'
                className='me-2'
                value={factura}
                onChange={(e) => setFactura(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            <FormControl
                placeholder='Cliente'
                className='me-2'
                value={cliente}
                onChange={(e) => setCliente(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            <FormControl
                placeholder='Guia'
                className='me-2'
                value={numGuia}
                onChange={(e) => setGuia(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            <FormControl
                type='date'
                className='me-2'
                value={creacion}
                onChange={(e) => setCreacion(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            <FormControl
                placeholder='Total'
                className='me-2'
                value={total}
                onChange={(e) => setTotal(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            
            <Select
                className='me-2 w-100'
                options={estadoOptions}
                value={estado}
                onChange={setEstado}
                placeholder='Estado'
                menuPlacement="auto"  // Despliega hacia arriba o abajo dependiendo del espacio
                menuPortalTarget={document.body}  // Renderiza el menú en el body
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),  // Asegura que el menú esté siempre al frente
                    container: base => ({ ...base, position: 'relative', zIndex: 1050 }),
                }}
            />
            <ButtonGroup>
                <Button variant='danger' title='Buscar' onClick={handleSearch}><Search /></Button>
                <Button variant='dark' title='Limpiar' onClick={handleClear}><XSquare /></Button>
            </ButtonGroup>
        </div>
    );
}

export default FiltroFacturas;
